import React from 'react'
import { useWizardMaster } from '../../../../../Contexts/WizardMasterContext'
import { Select } from 'antd'

const { Option } = Select

export const LocationSelect = ({ defaultLocation, accessor }) => {
  const { updateBackhaulField, backhaulMeta } = useWizardMaster()
  const selectOnChange = (value) => {
    updateBackhaulField(accessor, value)
  }
  return (
    <Select
      style={{ minWidth: 200 }}
      defaultValue={backhaulMeta && backhaulMeta.locations.find((o) => o === defaultLocation)}
      optionFilterProp='children'
      showSearch
      onSelect={selectOnChange}
    >
      {backhaulMeta &&
        backhaulMeta.locations.map((cp, i) => (
          <Option key={i} value={cp}>
            {cp}
          </Option>
        ))}
    </Select>
  )
}
